<div class="content">
    <mat-card *ngIf="form">
        <form [formGroup]="form">
            <div *ngFor="let question of category?.surveyQuestions" [ngSwitch]="question.questionCtrlTypeId">
                <div *ngSwitchCase="CONTROL_TYPES.SINGLE_CHOICE">
                    <ng-template [ngTemplateOutlet]="singleChoice" [ngTemplateOutletContext]="{ question: question }">
                    </ng-template>
                </div>
                <div *ngSwitchCase="CONTROL_TYPES.MULTIPLE_CHOICE">
                    <ng-template [ngTemplateOutlet]="multipleChoice" [ngTemplateOutletContext]="{ question: question }">
                    </ng-template>
                </div>
                <div *ngSwitchCase="CONTROL_TYPES.FREE_TEXT">
                    <ng-template [ngTemplateOutlet]="freeText" [ngTemplateOutletContext]="{ question: question }">
                    </ng-template>
                </div>
                <div *ngSwitchCase="CONTROL_TYPES.NUMBERIC_TEXT">
                    <ng-template [ngTemplateOutlet]="numeric" [ngTemplateOutletContext]="{ question: question }">
                    </ng-template>
                </div>
                <div *ngSwitchCase="CONTROL_TYPES.SELECT_ALL_THAT_APPLY">
                    <ng-template [ngTemplateOutlet]="allThatApply" [ngTemplateOutletContext]="{ question: question }">
                    </ng-template>
                </div>

            </div>
        </form>
        <div class="save-button">
          <button id="save-survey-btn" (click)="saveSurvey()"  mat-flat-button color="primary">
            {{ "Save" | translate }}
          </button>
        </div>
    </mat-card>
</div>

<ng-template #singleChoice let-question="question">
    <div class="row">
      <div class="col-sm-12">
        <mat-label class="question-label">{{ languageUtil.translateSurveyQuestion(allLang, question, currentLangCode) }} </mat-label>
        <mat-form-field class="form-field select-answer" appearance="standard">
            <mat-select  [required]="question.requireAnswer"  [formControl]="form.controls[question.id]">
              <mat-option value="">{{
                "Select an option" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let opt of question.questionOptions"
                [value]="opt.description"
                >{{ languageUtil.translateSurveyQuestion(allLang, opt, currentLangCode) }}</mat-option
              >
            </mat-select>
          </mat-form-field>
      </div>
    </div>
</ng-template>

<ng-template #multipleChoice let-question="question" >
    <div class="row">
      <div class="col-sm-12">
        <mat-label class="question-label">{{ languageUtil.translateSurveyQuestion(allLang, question, currentLangCode) }} </mat-label>
        <ng-select
        name="pathwaysIds"
        [multiple]="true"
        [formControl]="form.controls[question.id]">
          <ng-option
            *ngFor="let opt of question.questionOptions; let i = index"
            [value]="opt.description"
            required >
            {{ languageUtil.translateSurveyQuestion(allLang, opt, currentLangCode) }}
          </ng-option>
        </ng-select>
      </div>
    </div>
</ng-template>

<ng-template #freeText let-question="question" >
    <div *ngIf='showEncrytedQuestion(question)' class="row">
      <div class="col-sm-12">
        <mat-label class="question-label">{{ languageUtil.translateSurveyQuestion(allLang, question, currentLangCode) }} </mat-label>
        <mat-form-field class="form-field" appearance="legacy">
          <input matInput required="question.requireAnswer"  [formControl]="form.controls[question.id]"/>
        </mat-form-field>
      </div>
    </div>
</ng-template>

<ng-template #numeric let-question="question" >
    <div class="row">
      <div class="col-sm-12">
        <mat-label class="question-label">{{ languageUtil.translateSurveyQuestion(allLang, question, currentLangCode) }} </mat-label>
        <mat-form-field class="form-field" appearance="legacy">
          <input matInput [required]="question.requireAnswer" [formControl]="form.controls[question.id]" />
        </mat-form-field>
      </div>
    </div>
</ng-template>

<ng-template #allThatApply let-question="question" >
  <div class="row">
    <div class="col-sm-12">
      <mat-label class="question-label">{{ languageUtil.translateSurveyQuestion(allLang, question, currentLangCode) }} </mat-label>
      <ng-select
      name="pathwaysIds"
      [multiple]="true"
      [formControl]="form.controls[question.id]"
      (change)="eventChange($event, question)">
      <ng-option
        id="select-all"
        [value]="-1"
        required >
        {{ "Select all" | translate }}
      </ng-option>
        <ng-option
          *ngFor="let opt of question.questionOptions; let i = index"
          [value]="opt.description"
          required >
          {{ languageUtil.translateSurveyQuestion(allLang, opt, currentLangCode) }}
        </ng-option>
      </ng-select>
    </div>
  </div>
</ng-template>